<template>
  <v-dialog
    v-model="getValue"
    content-class="sidebarDialog"
    hide-overlay
  >
    <v-container class="pa-6 pb-3">
      <v-row>
        <v-col
          class="d-flex justify-space-between align-center"
        >
          <span class="h5Header secondary400">{{ title }}</span>
          <v-btn
            id="closeSidebar"
            icon
            class="closeSidebarDialogButton"
            @click="getValue = false"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="pa-0 ma-0" />
    <v-container
      class="pa-6"
      style="flex-grow: 1"
    >
      <v-row class="fill-height">
        <v-col class="fill-height">
          <slot />
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: 'SidebarDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

};
</script>
